import { ref, computed } from 'vue';
import { defineStore } from 'pinia';
import { setAuthState } from "../composables/auth"

import WON_SERVICES from "../utils/services"

const { getUser } = setAuthState();

export const useCareerCoach = defineStore('career-coach', () => {
    const userTier = ref(null)

    const init = () => {
        const user = getUser();
       
        let career_status = user?.options?.career_status;
        
        if(!career_status || career_status === 'Not Working') {
            career_status = 'Student'
        }
        
        userTier.value = career_status
    }

    const servicesForUserTier = computed(() => {
        return WON_SERVICES[userTier.value]
    })

    const setServicesUserTier = (userTierService) => {
        userTier.value = userTierService.value
    }
    
    const getServicesForUserTier = () => {
        let career_status = getUser()?.options?.career_status;
        
        if(!career_status || career_status === 'Not Working') {
            career_status = 'Student'
        }
        return WON_SERVICES[career_status];
    }

    return {
        servicesForUserTier,
        userTier,

        getServicesForUserTier,
        init,
        setServicesUserTier
    }
})
